import { adminHttpClient } from "../../../commons/adminHttpClinet"
import { TransactionWithdrawalSearch, WithdrawalTransactionModel } from "../../../models/dashboard/transactions/transation"

const getTransactionWithdrawalByTransfer = (model: TransactionWithdrawalSearch) : Promise<WithdrawalTransactionModel> =>{
    return adminHttpClient.get(`/api/Admin/AdminTransactions/get-transaction-withdrawal?userId=${model.userId}&transferId=${model.transferId}`); 
}

export default getTransactionWithdrawalByTransfer;